import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

export function NotFoundPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
        textAlign: 'center',
        p: 4,
      }}
    >
      <Typography variant="h4" component="h1">
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary">
        The page you&apos;re looking for doesn&apos;t exist.
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        Go to home
      </Button>
    </Box>
  );
}
